import { render, staticRenderFns } from "./ContentSources.vue?vue&type=template&id=131b06d8"
import script from "./ContentSources.vue?vue&type=script&lang=js"
export * from "./ContentSources.vue?vue&type=script&lang=js"
import style0 from "./ContentSources.vue?vue&type=style&index=0&id=131b06d8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports